define([
    "underscore",
    "backbone",
    "views/base",
    "components/modal",
    "components/modal-question",
    "components/noti",
    "components/yii-js-router",
    "utils/number-formatter",
    "backbone.overrides"
], function(_, Backbone, BaseView, Modal, ModalQuestion, Noti, YiiJsRouter, NumberFormatter) {
        "use strict";

        const methodMap = {
            create: "POST",
            update: "PUT",
            delete: "DELETE",
            read:   "GET"
        };

        Backbone.sync = function(method, model, options) {
            var type = methodMap[method];

            // Default options, unless specified.
            _.defaults(options || (options = {}), {
                emulateHTTP: Backbone.emulateHTTP,
                emulateJSON: Backbone.emulateJSON
            });

            // Default JSON-request options.
            var params = {type: type, dataType: "json"};

            // Ensure that we have a URL.
            if (!options.url) {
                params.url = _.result(model, "url") || urlError();
            }

            // Ensure that we have the appropriate request data.
            if (options.data == null && model && (method === "create" || method === "update" || method === "patch")) {
                params.contentType = "application/json";
                if (options.attrs) {
                    params.data = JSON.stringify(options.attrs);
                } else if (options.noEmpty) {
                    params.data = JSON.stringify(_.omit(model.getSyncAttrs(), function(value) {
                        return (value ? false : true);
                    }));
                } else {
                    params.data = JSON.stringify(model.getSyncAttrs());
                }
            }

            // For older servers, emulate JSON by encoding the request into an HTML-form.
            if (options.emulateJSON) {
                params.contentType = "application/x-www-form-urlencoded";
                params.data = params.data ? {model: params.data} : {};
            }

            // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
            // And an `X-HTTP-Method-Override` header.
            if (type === "POST" || type === "PUT" || type === "DELETE" || type === "PATCH") {
                if (options.emulateJSON) params.data._method = type;
                var beforeSend = options.beforeSend;
                options.beforeSend = function(xhr) {
                    xhr.setRequestHeader("X-CSRF-Token", App.Constants.CSRF_TOKEN);
                    if (beforeSend) return beforeSend.apply(this, arguments);
                };
            };

            // Don"t process data on a non-GET request.
            if (params.type !== "GET" && !options.emulateJSON) {
                params.processData = false;
            }

            // If we"re sending a `PATCH` request, and we"re in an old Internet Explorer
            // that still has ActiveX enabled by default, override jQuery to use that
            // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
            if (params.type === "PATCH" && noXhrPatch) {
                params.xhr = function() {
                    return new ActiveXObject("Microsoft.XMLHTTP");
                };
            }

            // Make the request, allowing the user to override any Ajax options.
            var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
            model.trigger("request", model, xhr, options);
            return xhr;
        };

        const InitialApp = window.App

        const App = _.extend({}, InitialApp, {
            Views: [],
            Modals: {},
            Events: _.extend({}, Backbone.Events),

            View: BaseView,
            UrlHelper: new YiiJsRouter(),

            init ({ router, user }) {
                this.User = user;
                this.LocalRouter = router;

                // Views
                this.Modal = new Modal();
                this.ModalQuestion = new ModalQuestion();
                this.Noti  = new Noti({
                    el: ".js-noti-top",
                    animationOpen: "fadeInDown",
                    animationClose: "fadeOutUp"
                });
            },

            urlTo (path, params) {
                var url = this.UrlHelper.generateUrl(App.Constants.COUNTRY + '/' + path, params);
                if (!url) {
                    return this.UrlHelper.generateUrl(path, params);
                }
                return url;
            },

            urlRegexTo (path, params) {
                return this.UrlHelper.generateRegexUrl(path, params);
            },

            asDecimal (number, precision) {
                return NumberFormatter.asDecimal(number, precision);
            },

            parseFloat (number) {
                return NumberFormatter.parseFloat(number);
            },
        });

        // Backwards compatibility for global App access
        window.App = App

        return App
    });
